import {
  specialreplace, specialremove, firstspecialreplace, standardTypeSpecialRemove,
} from '@/filters/specialreplace';

/**
 * Maps **Bet Header Name** according to stated rules in #T123572
 * @param {String} betName
 * @param {[String, Boolean]} sv
 * @param {String} template
 * @param {Number} outcomesLength
 * @param {Boolean} specialMarket
 * @returns {String}
 */

export default function mapBetName(betName, sv, template, outcomesLength, specialMarket) {
  if (template === 'Standard' || !sv) return standardTypeSpecialRemove(betName);

  const specialValues = sv.toString().split('|');

  if (outcomesLength > 2 || specialValues.length > 2) return specialreplace(betName, sv);

  if (outcomesLength === 2 && specialValues.length === 2) {
    return specialMarket
      ? firstspecialreplace(betName, sv)
      : specialreplace(betName, sv);
  }

  return specialremove(betName, sv);
}
